import React, { useState } from 'react';
import { FaUmbrellaBeach, FaMountain, FaTree, FaHome, FaWater, FaSeedling } from 'react-icons/fa';
import { HiSun } from 'react-icons/hi';
import ModuleHeader from "../../moduleHeader";

const defaultPackageData = {
  user: {
    first_name: "Kullanıcı",
    last_name: ""
  },
  package: {
    name: "Peaceful Place",
    description: "Kendinizi huzurlu hissettiğiniz bir yeri seçin ve detaylandırın. Ses, koku, renk sorularıyla bu yeri canlandırın.",
    image_url: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80"
  }
};

const placeTypes = [
  { id: 1, name: "Plaj", icon: FaUmbrellaBeach, image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&q=80" },
  { id: 2, name: "Dağ", icon: FaMountain, image: "https://images.unsplash.com/photo-1464822759844-d150ad2996e3?w=400&q=80" },
  { id: 3, name: "Orman", icon: FaTree, image: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&q=80" },
  { id: 4, name: "Çocukluk Evi", icon: FaHome, image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=400&q=80" },
  { id: 5, name: "Göl", icon: FaWater, image: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=400&q=80" },
  { id: 6, name: "Bahçe", icon: FaSeedling, image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&q=80" }
];

export default function PeacefulPlace({ id, moduleId, isOwner }) {
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [step, setStep] = useState(1);
  const [placeDetails, setPlaceDetails] = useState({
    sounds: '',
    smells: '',
    colors: '',
    feelings: ''
  });
  const [packageData] = useState(defaultPackageData);
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);

  const handlePlaceSelect = (place) => {
    setSelectedPlace(place);
    setStep(2);
  };

  const handleDetailChange = (key, value) => {
    setPlaceDetails(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleNext = () => {
    if (step < 5) {
      setStep(step + 1);
    }
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleRestart = () => {
    setSelectedPlace(null);
    setStep(1);
    setPlaceDetails({
      sounds: '',
      smells: '',
      colors: '',
      feelings: ''
    });
  };

  const steps = [
    { id: 1, title: "Yer Seç", question: "Huzurlu hissettiğiniz bir yer seçin" },
    { id: 2, title: "Sesler", question: "Bu yerde hangi sesleri duyuyorsunuz?", key: "sounds" },
    { id: 3, title: "Kokular", question: "Bu yerde hangi kokuları alıyorsunuz?", key: "smells" },
    { id: 4, title: "Renkler", question: "Bu yerde hangi renkleri görüyorsunuz?", key: "colors" },
    { id: 5, title: "Hissettikleriniz", question: "Bu yerde nasıl hissediyorsunuz?", key: "feelings" }
  ];

  const currentStepData = steps.find(s => s.id === step);

  return (
    <div className="w-full h-screen min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed] relative">
      <div className="flex flex-col items-center w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto">
        {/* ModuleHeader */}
        <div className="relative z-30 w-full mb-2">
          <ModuleHeader
            userName={packageData.user?.first_name + " " + packageData.user?.last_name}
            subtitle={packageData.package?.name + " Modülüne Hoş Geldiniz"}
            title={packageData.package?.name}
            description={packageData.package?.description}
            backgroundImage={packageData.package?.image_url}
            onExpandedChange={setIsHeaderExpanded}
            showToggle={true}
            autoHeight={true}
          />
        </div>

        <div className="w-full px-6 py-8 pb-24 flex-1">
          {step === 1 ? (
            <>
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">Huzurlu Yerinizi Seçin</h2>
              <div className="grid grid-cols-2 gap-4">
                {placeTypes.map((place) => {
                  const IconComponent = place.icon;
                  return (
                  <button
                    key={place.id}
                    onClick={() => handlePlaceSelect(place)}
                    className="bg-white border-2 border-gray-200 rounded-xl p-4 hover:border-[#3DA7B5] hover:shadow-lg transition-all duration-200 transform hover:scale-105"
                  >
                    <div className="flex justify-center mb-2">
                      <IconComponent className="text-4xl text-[#3DA7B5]" />
                    </div>
                    <div className="text-sm font-semibold text-gray-800">{place.name}</div>
                  </button>
                  );
                })}
              </div>
            </>
          ) : step < 5 ? (
            <>
              {/* Progress */}
              <div className="mb-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs text-gray-500">Adım {step} / 4</span>
                  <span className="text-xs text-gray-500">{Math.round((step / 4) * 100)}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div 
                    className="bg-gradient-to-r from-[#3DA7B5] to-[#5ABCC8] h-2 rounded-full transition-all duration-500"
                    style={{ width: `${(step / 4) * 100}%` }}
                  ></div>
                </div>
              </div>

              {selectedPlace && (
                <div className="mb-6 text-center">
                  <div className="flex justify-center mb-2">
                    {(() => {
                      const IconComponent = selectedPlace.icon;
                      return <IconComponent className="text-6xl text-[#3DA7B5]" />;
                    })()}
                  </div>
                  <p className="text-lg font-semibold text-gray-700">{selectedPlace.name}</p>
                </div>
              )}

              <div className="bg-gradient-to-br from-green-50 to-teal-50 border border-green-200 rounded-2xl p-6 mb-6">
                <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">{currentStepData.title}</h3>
                <p className="text-gray-600 mb-6 text-center">{currentStepData.question}</p>
                
                <textarea
                  value={placeDetails[currentStepData.key] || ''}
                  onChange={(e) => handleDetailChange(currentStepData.key, e.target.value)}
                  placeholder="Detaylarınızı yazın..."
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#3DA7B5] focus:border-transparent resize-none"
                  rows="5"
                />
              </div>

              <div className="flex gap-3">
                <button
                  onClick={handleBack}
                  className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-xl py-3 font-semibold transition-all duration-200"
                >
                  ← Geri
                </button>
                <button
                  onClick={handleNext}
                  disabled={!placeDetails[currentStepData.key]?.trim()}
                  className={`flex-1 bg-gradient-to-r from-[#3DA7B5] to-[#5ABCC8] text-white rounded-xl py-3 font-semibold transition-all duration-200 ${
                    !placeDetails[currentStepData.key]?.trim() 
                      ? 'opacity-50 cursor-not-allowed' 
                      : 'hover:from-[#2F8894] hover:to-[#4A9BA6] transform hover:scale-[1.02]'
                  }`}
                >
                  İleri →
                </button>
              </div>
            </>
          ) : (
            <div className="text-center animate-fadeIn">
              <div className="flex justify-center mb-6">
                <HiSun className="text-8xl text-yellow-500 animate-bounce" />
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Huzurlu Yeriniz Hazır!</h2>
              <p className="text-gray-600 mb-8">
                Artık bu yere 'gitmiş' gibi hissedebilirsiniz. İhtiyaç duyduğunuzda buraya dönebilirsiniz.
              </p>

              {selectedPlace && (
                <div className="bg-gradient-to-br from-green-50 to-teal-50 border border-green-200 rounded-2xl p-6 mb-6 text-left">
                  <div className="text-center mb-4">
                    <div className="flex justify-center mb-2">
                      {(() => {
                        const IconComponent = selectedPlace.icon;
                        return <IconComponent className="text-6xl text-[#3DA7B5]" />;
                      })()}
                    </div>
                    <h3 className="text-xl font-bold text-gray-800">{selectedPlace.name}</h3>
                  </div>
                  <div className="space-y-3 text-sm">
                    <div>
                      <p className="font-semibold text-gray-700">Sesler:</p>
                      <p className="text-gray-600">{placeDetails.sounds}</p>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-700">Kokular:</p>
                      <p className="text-gray-600">{placeDetails.smells}</p>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-700">Renkler:</p>
                      <p className="text-gray-600">{placeDetails.colors}</p>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-700">Hissettikleriniz:</p>
                      <p className="text-gray-600">{placeDetails.feelings}</p>
                    </div>
                  </div>
                </div>
              )}

              <div className="space-y-3">
                <button
                  onClick={() => setStep(1)}
                  className="w-full bg-gradient-to-r from-[#3DA7B5] to-[#5ABCC8] hover:from-[#2F8894] hover:to-[#4A9BA6] text-white rounded-xl py-4 font-semibold text-lg transition-all duration-200 transform hover:scale-[1.02] shadow-lg"
                >
                  Bu Yere Git
                </button>
                <button
                  onClick={handleRestart}
                  className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-xl py-3 font-semibold transition-all duration-200"
                >
                  Yeni Yer Oluştur
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

